module.exports = __webpack_public_path__ + "static/media/Elisa Tagliacozzo.0a630115.png";